import BaseApi from '@lumapps/base-api';
import { get } from '@lumapps/constants';

const Config = get();

export const SynApi = new BaseApi({
    baseURL: Config.synUrl,
});

/**
 * get the saved list of qr code rules
 * @return {Promise} The request promise.
 */

export const getProviders = (organizationDomain: string, nextUrl?: string) => {
    const domain = organizationDomain;
    return SynApi.get('urls', {
        params: { domain, nextUrl },
    });
};
